import API from "../../../api"
import { useState, useEffect } from "react"
import { Typography, Box } from "@mui/material";
import { BarChart } from '@mui/x-charts';
import { logColor } from "../../../theme";

const HighGraph = ({ colors, names }) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);
    useEffect(() => {
        setLoad(true);
        API.getWeeklyDataLecs({ types: [0, 1], queryType: "graph" }).then((result) => {
            const newData = [];
            result.data.forEach((item) => {
                let lecs = names.find((name) => name.seriale === item.fkSeriale);
                const high = item.types.find((f) => f.tipo === 0);
                const critical = item.types.find((f) => f.tipo === 1);
                newData.push({ lecs: lecs.nomeLecs || lecs.matricola, critical: critical ? critical.count : 0, high: high ? high.count : 0 });
            })
            setData(newData);
            setLoad(false);
        }).catch((err) => {});
    }, [names]);

    return (
        <Box className="highGraph" sx={{
            border: "3px solid #449095",
            background: "#1E1E1E",
            borderRadius: "15px",
            height: "100%"
        }}>
            <Typography sx={{
                ml: 2,
                mt: 2,
                fontSize: 20
            }}>
                Weekly Data
            </Typography>
            <BarChart
                sx={{
                    marginTop: 2
                }}
                dataset={data}
                loading={load}
                series={[
                    { dataKey: "critical", label: "Critical", color: logColor[1] },
                    { dataKey: "high", label: "High", color: logColor[0] }
                ]}
                height={300}
                xAxis={[{ scaleType: "band", dataKey: "lecs" }]}
            />
        </Box>
    )
}

export default HighGraph;
